<template>
  <CompanyObjectRefSelect
    v-model="vModel"
    :options="companyFilterOptions"
    :mode="mode"
    object-type="company_filter"
    placeholder="Filter"
    external-path="/definitions"
    :external-query="{
      tab: 'filters',
    }" />
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import CompanyObjectRefSelect from '@/components/reports/config/common/CompanyObjectRefSelect'

  export default {
    name: 'CompanyFilterRefSelect',
    components: {
      CompanyObjectRefSelect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
  }
</script>

<style lang="scss" scoped>

</style>
